import { injectable } from 'inversify';

export type LocalStorageItemKeys = 'products'; // To easily retrieve elements. Values can be extended.

@injectable()
export class LocalStorageGateway {
  saveItem = (key: LocalStorageItemKeys, value: any) => {
    localStorage.setItem(key, JSON.stringify({ value }));
  };

  getItem = <T>(key: LocalStorageItemKeys): T | undefined => {
    const strValue = localStorage.getItem(key);
    const json = strValue ? JSON.parse(strValue) : undefined;
    return json?.value;
  };
}
